// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"700":"78e8ba20","808":"ca5ccba7","896":"b1c80a70"}[chunkId] + ".chunk.css";
};